import { APPLY_GIFT_VOUCHER } from '../../../constants/actionConstants';
import paymentTypeConstants from '../../../constants/paymentTypeConstants';
import makeGiftOptionsReducer from './giftOptionsHigherOrderReducer';

export const INITIAL_STATE = {
  isLoading: false,
  formSubmitFailed: false,
  errorMessage: undefined,
};

export default makeGiftOptionsReducer({
  INITIAL_STATE,
  ACTION_NAME: APPLY_GIFT_VOUCHER,
});

export const getGiftVoucherRemovedOptions = (state) => {
  const { giftVoucher: { removedOptions = [] } = {} } = state;
  return removedOptions;
};

export const giftVouchersSelector = (state, context) => {
  const { orderForm: { payments = [] } } = state;
  return payments
    .filter(payment => payment.type === paymentTypeConstants.GIFT_VOUCHER)
    .filter(payment => !payment.isRemoved || (payment.isRemoved && payment.removalContext === context))
    .map(payment => ({
      ...payment,
      serialNumber: payment.details.serialNumber,
      securityCode: payment.details.securityCode,
    }));
};
